import { motion } from "framer-motion";
import { FC } from "react";
import successImage from "@assets/lottie/r2dog2Success.json";
import errorImage from "@assets/lottie/r2dog2Error.json";
import styles from "./StatusMessage.module.scss";
import { Player } from "@lottiefiles/react-lottie-player";

interface IStatusMessageProps {
  status: "success" | "error";
  successType?: string;
  errorMessage?: string;
}

export const StatusMessage: FC<IStatusMessageProps> = (props) => {
  const { status, successType, errorMessage } = props;

  return (
    <motion.div
      key="status"
      className={styles.statusContainer}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.8 }}
    >
      <p className={styles.statusMessage}>
        {status === "success"
          ? `${successType}`
          : errorMessage || "Произошла ошибка при сохранении"}
      </p>
      <Player
        autoplay
        loop
        src={status === "success" ? successImage : errorImage}
        className={styles.statusImage}
      />
    </motion.div>
  );
};
